export const EqualValueMeasures = [
  'GDPManualFcstAdjustmentPct',
  'GDPPromoFcstAdjustmentPct',
  'RDPManualFcstAdjustmentPct',
  'RDPPromoFcstAdjustmentPct',
  'CustomerInStockEstimate',
  'AccountTargetFWOS',
  'DistiTargetFWOS',
  'AlgoTFvsGDPTotalForecastPct',
  'AlgoTFvsUDPLikelyTotalFcstPct',
  'AlgoTFvsRDPTotalForecastPct',
  'GDPTotalFcstvsUDPLikelyTotalFcstPct',
  'GDPTotalFcstvsCustomerSTFcstPct',
  'GDPTotalFcstvsSalesGoalPct',
  'GDPTotalFcstvsCOSellThruOverrideFcstPct',
  'GDPTotalFcstvsActualSTPct',
  'RDPTotalFcstvsUDPLikelyTotalFcstPct',
  'RDPTotalFcstvsCustomerSTFcstPct',
  'RDPTotalFcstvsSalesGoalPct',
  'RDPTotalFcstvsCOSellThruOverrideFcstPct',
  'RDPTotalFcstvsActualSTPct',
  'UDPLikelyTotalFcstvsActualSTPct',
  'UDPLikelyTotalFcstvsCustomerSTFcstPct',
  'CPFRSTOverrideFcstvsUDPLikelyTotalFcstPct',
  'CustomerInStockEstimatePct',
  'ActualSTvsUDPLikelyTotalFcstPct',
  'ActualSTvsConstrainedSTFcstPct',
  'ActualSTvsCustomerSTFcstPct',
  'ActualSTvsCPFRSTOverrideFcstPct',
  'ActualSTWOWPct',
  'UDPHighTotalFcstvsUDPLikelyTotalFcstPct',
  'UDPLowTotalFcstvsUDPLikelyTotalFcstPct',
  'GDPHighTotalFcstvsGDPTotalFcstPct',
  'GDPLowTotalFcstvsGDPTotalFcstPct',
  'GDPHighTotalFcstvsUDPHighTotalFcstPct',
  'GDPLowTotalFcstvsUDPLowTotalFcstPct',
  'RDPHighTotalFcstvsRDPTotalFcstPct',
  'RDPLowTotalFcstvsRDPTotalFcstPct',
  'RDPHighTotalFcstvsUDPHighTotalFcstPct',
  'RDPLowTotalFcstvsUDPLowTotalFcstPct',
  'GDPHighTotalFcstvsRDPHighTotalFcstPct',
  'GDPTotalForecastvsRDPTotalForecastPct',
  'GDPLowTotalForecastvsRDPLowTotalForecastPct',
  'RDPHighTotalForecastvsGDPHighTotalForecastPct',
  'RDPTotalForecastvsGDPTotalForecastPct',
  'RDPLowTotalForecastvsGDPLowTotalForecastPct',
  'LYCustomerInStockEstimatePct',
  'TYActualSTvsLYActualSTPct',
  'GDPTotalFcstvsLYActualSTPct',
  'RDPTotalFcstvsLYActualSTPct',
  'UDPLikelyTotalFcstvsLYActualSTPct',
  'GDPPromoFcstAdjustmentPct',
  'RDPPromoFcstAdjustmentPct',
  'TYDistiActualSTvsLYDistiActualSTPct',
  'CasepackQty',
  'DistiCasepackQty',
  'DistiPalletQty',
  'PalletQty',
  'AccountLeadTime',
  'RDPUDPProjectedWOS',
  'UDPSellInPORProjectedWOS',
  'UDPProjectedWOS',
  'AlgoBaselineAttachRatevsGDPBaselineAttachRate',
  'AlgoBaselineAttachRatevsRDPBaselineAttachRate'
];
















